import React, { useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import workdata from '../common/API/WorkAPI.json';
import romancedata from '../common/API/RomanceAPI.json';
import funnydata from '../common/API/FunnyAPI.json';
import devdata from '../common/API/DevAPI.json';
import fooddata from '../common/API/FoodAPI.json';
import covertdata from '../common/API/CovertAPI.json';
import KakaoAdfit1 from '../KakaoAdfit/KakaoAdfit1';
import KakaoAdfit2 from '../KakaoAdfit/KakaoAdfit2';
import KakaoAdfit3 from '../KakaoAdfit/KakaoAdfit3';
import KakaoAdfit4 from '../KakaoAdfit/KakaoAdfit4';
import { isMobile, isTablet } from '../common/style';

const StartPage: React.FC = () => {
  const [array, setArray] = useState<number[]>([]);

  const workshuffle = () => {
    for (let i = 0; i < workdata.length; i++) {
      array.push(i);
    }
    const shuffledArray = array.sort(() => Math.random() - 0.5);
    setArray(shuffledArray);
  };

  const romanceshuffle = () => {
    for (let i = 0; i < romancedata.length; i++) {
      array.push(i);
    }
    const shuffledArray = array.sort(() => Math.random() - 0.5);
    setArray(shuffledArray);
  };

  const funnyshuffle = () => {
    for (let i = 0; i < funnydata.length; i++) {
      array.push(i);
    }
    const shuffledArray = array.sort(() => Math.random() - 0.5);
    setArray(shuffledArray);
  };

  const foodshuffle = () => {
    for (let i = 0; i < fooddata.length; i++) {
      array.push(i);
    }
    const shuffledArray = array.sort(() => Math.random() - 0.5);
    setArray(shuffledArray);
  };

  const devshuffle = () => {
    for (let i = 0; i < devdata.length; i++) {
      array.push(i);
    }
    const shuffledArray = array.sort(() => Math.random() - 0.5);
    setArray(shuffledArray);
  };

  const covertshuffle = () => {
    for (let i = 0; i < covertdata.length; i++) {
      array.push(i);
    }
    const shuffledArray = array.sort(() => Math.random() - 0.5);
    setArray(shuffledArray);
  };

  return (
    <Center>
      <h1>밸런스게임</h1>
      <Container>
        <GameLink
          to="/select"
          onClick={workshuffle}
          state={{ array, select: 'work' }}
        >
          직장인 밸런스 게임
        </GameLink>
        <GameLink
          to="/select"
          onClick={romanceshuffle}
          state={{ array, select: 'romance' }}
        >
          연애 밸런스 게임
        </GameLink>
        <GameLink
          to="/select"
          onClick={funnyshuffle}
          state={{ array, select: 'funny' }}
        >
          웃긴 밸런스 게임
        </GameLink>
        <GameLink
          to="/select"
          onClick={foodshuffle}
          state={{ array, select: 'food' }}
        >
          음식 밸런스 게임
        </GameLink>
        <GameLink
          to="/select"
          onClick={devshuffle}
          state={{ array, select: 'dev' }}
        >
          개발자 밸런스 게임
        </GameLink>
        <GameLink
          to="/select"
          onClick={covertshuffle}
          state={{ array, select: 'covert' }}
        >
          19금 밸런스 게임
        </GameLink>
      </Container>
      <KakaoAdfitDiv1>
        <KakaoAdfit1 />
      </KakaoAdfitDiv1>
      <KakaoAdfitDiv2>
        <KakaoAdfit2 />
      </KakaoAdfitDiv2>
      <KakaoAdfitDiv>
        <KakaoAdfit3 />
        <KakaoAdfit4 />
      </KakaoAdfitDiv>
    </Center>
  );
};

export default StartPage;

const Center = styled.div`
  display: flex;
  position: fixed;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  left: 0;
  right: 0;
  transition: 0.5s;

  h1 {
    font-size: 27px;
    font-weight: 700;
    line-height: 150%;
    font-family: GmarketSansBold;
    color: #4da082;

    margin-top: 63px;
    margin-bottom: 67px;

    ${isTablet} {
      font-size: 25px;
      margin-top: 40px;
      margin-bottom: 36px;
    }

    ${isMobile} {
      font-size: 22px;
      margin-top: 35px;
      margin-bottom: 30px;
    }
  }
`;

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 70px;
  margin-bottom: 63px;

  ${isTablet} {
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
    margin-bottom: 20px;
  }

  ${isMobile} {
    grid-template-columns: 1fr;
    gap: 25px;
    height: 350px;
    overflow: auto;
    padding: 5px 10px;
    margin-bottom: 10px;
  }

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: #cae2db;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }
`;

const GameLink = styled(Link)`
  width: 380px;
  height: 190px;

  border-radius: 40px;
  border: 3px solid #3d6c5b;
  background: #dcf0e9;
  box-shadow: 4px 4px 4px 0px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;

  color: #2e674b;
  font-family: 'GmarketSansBold';
  font-size: 27px;
  font-weight: 700;
  text-decoration: none;

  &:hover {
    cursor: pointer;
    background: #99d7c1;
  }

  ${isTablet} {
    width: 300px;
    height: 155px;
    border-radius: 30px;
    font-size: 24px;
  }

  ${isMobile} {
    width: 250px;
    height: 130px;
    font-size: 20px;
    border: 2px solid #3d6c5b;
  }
`;

const KakaoAdfitDiv1 = styled.div`
  margin-right: 1530px;
  position: absolute;

  ${isTablet} {
    margin-right: 900px;
  }
`;

const KakaoAdfitDiv2 = styled.div`
  margin-left: 1530px;
  position: absolute;

  ${isTablet} {
    margin-left: 900px;
  }
`;

const KakaoAdfitDiv = styled.div`
  position: relative;
`;
